import React from 'react';
import { Layout, Menu, Avatar, Row, Col, Typography, Card, Button } from 'antd';
import {
  HomeOutlined,
  SettingOutlined,
  FileTextOutlined,
  BellOutlined,
  UserOutlined,
} from '@ant-design/icons';

const { Header, Content, Footer, Sider } = Layout;
const { Text, Title } = Typography;

const App = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider breakpoint="lg" collapsedWidth="0">
        <div style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: 24 }}>Logo</div>
        <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
          <Menu.Item key="1" icon={<HomeOutlined />}>Home</Menu.Item>
          <Menu.Item key="2" icon={<FileTextOutlined />}>Shipments</Menu.Item>
          <Menu.Item key="3" icon={<SettingOutlined />}>Settings</Menu.Item>
        </Menu>
      </Sider>
      <Layout>
        <Header style={{ padding: '0 20px', background: '#F0F2F5' }}>
          <Row justify="space-between" align="middle">
            <Title level={4} style={{ margin: 0, color: '#3D81FF' }}>ZoomLogi</Title>
            <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#87d068' }} />
          </Row>
        </Header>
        <Content style={{ margin: '20px' }}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <Card>
                <Title level={4}>2</Title>
                <Text>Critical alerts</Text>
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Title level={4}>3</Title>
                <Text>At risk</Text>
              </Card>
            </Col>
            <Col span={8}>
              <Card>
                <Title level={4}>101</Title>
                <Text>On track</Text>
              </Card>
            </Col>
          </Row>
          <Button type="primary" style={{ marginTop: '20px' }}>New Shipment</Button>
        </Content>
        <Footer style={{ textAlign: 'center' }}>ZoomLogi ©2024</Footer>
      </Layout>
    </Layout>
  );
};

export default App;